import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	ricCode:'m-investor-overview__dax-ricCode',
	quote:'m-investor-overview__dax-quote',
	change:'m-investor-overview__dax-change',
	update:'m-investor-overview__dax-update',
};

@createModule('InvestorOverview')
/**
 * investor-overview module implementation.
 *
 */
export class InvestorOverview extends TerrificSpec {
	$ctx: JQuery;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);

		var me = this;
	
		setTimeout(() => {
			me.getDaxData();
		}, 0);

		resolve();
	}

	getDaxData(){
		const configuration = this.$ctx.data("configuration");
		const apiEndpoint = this.$ctx.data("api-endpoint");
		$.ajax({
			type: 'POST',
			url: apiEndpoint,
			dataType: 'html',
			data:
			{
				Configuration: configuration
			},
			success: (response: any) => {
				console.log("success");
				if(response!=null){
				var jsonData=JSON.parse(response);
				this.$ctx.find(`.${classes.ricCode}`).text(jsonData.riccode);
				this.$ctx.find(`.${classes.quote}`).text(jsonData.quote);
				this.$ctx.find(`.${classes.change}`).text(jsonData.change);
				this.$ctx.find(`.${classes.update}`).text(jsonData.update);
				if(jsonData.isincrease===true)
				{
					if(!this.$ctx.find(`.${classes.quote}`).hasClass("m-investor-overview__dax-increase"))
					{
					  this.$ctx.find(`.${classes.quote}`).addClass("m-investor-overview__dax-increase");
					}
				}
				if(jsonData.isincrease===false)
				{
					if(this.$ctx.find(`.${classes.quote}`).hasClass("m-investor-overview__dax-increase"))
					{
					 	this.$ctx.find(`.${classes.quote}`).removeClass("m-investor-overview__dax-increase");
					}
				}
			  }
			},
			complete: () => {
				
			},
			error: () => {
				console.log("get dax data error");
			}
		});
	}

	stop() {}
}
